import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S3DataUploadTable } from "./table";
import { S3DataUploadEdit } from "./edit";

export default function S3DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<S3DataUploadEdit />} />
      <Route index element={<S3DataUploadTable />} />
    </Routes>
  );
}
